import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef , MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource} from '@angular/material/table';
import { Subscription } from 'rxjs';
import { OrdersService } from '../../Service/order.service';
import { ManagePackageService } from '../services/manage-package.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { PackageRefreshDialogComponent } from '../package-refresh-dialog/package-refresh-dialog.component';

@Component({
    selector: 'app-print-specimen-dialog',
    templateUrl: './print-specimen-dialog.component.html',
    styleUrls: ['./print-specimen-dialog.component.scss'],
    standalone: false
})
export class PrintSpecimenDialogComponent implements OnInit {
  inputData: any;
  selectedOption: any;
  selectedOptionTemp: any;
  //private subscriptionList = new Array<Subscription>();
  selection = new SelectionModel<any>(true, []);
  dataSource = new MatTableDataSource<any>([]);
  private readonly subscriptions: Subscription[] = [];
  isLoading = false;
  displayedColumns: string[] = ['select', 'specimen'];

  constructor(
    public dialogRef: MatDialogRef<PrintSpecimenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private managePackageService: ManagePackageService,private orderService: OrdersService,
    private dialogService: DialogService,) { }

  ngOnInit() {
    this.inputData = this.data;
    if (this.data && this.data.Specimens) {
      this.dataSource = new MatTableDataSource<any>(this.data.Specimens);
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  close() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.dialogRef.close(this.selectedOption);
  }

  printLabels() {
    this.orderService.isPackageInCurrentStatus(this.inputData.LabPortPackageCode).subscribe(res => { 
      const isPackageInCurrentState = res as boolean; 
       if (!isPackageInCurrentState && this.inputData.Screen == 'Package') {
          this.GetConcurrentRefreshDialog();
        } else {
    const req = {
      RequisitionID: this.inputData.RequisitionID,
      SpecimenIds: this.selection.selected.map(x => x.SpecimenKitId)
    };
    this.isLoading = true;
    //this.subscriptions.push(
      const subscription = this.managePackageService.getPrintLabels(req).subscribe({
        next: (data) => {
          if (!data || data.length === 0) {
            alert('Improper data. Please setup data.');
          } else {
            const popUpWin = window.open('_blank', '', 'width=auto,height=100%');
            popUpWin.document.open();
            // NOSONAR: label HTML contains barcode-rendering script tags that only execute via document.write; trusted content from our backend service.
            popUpWin.document.write(data.labelData);
            popUpWin.document.close();
            popUpWin.print();
            popUpWin.close();
          }
        },
        error: (error) => {
          console.error(error);
          alert('Failed to fetch label data.');
        }
      });
       subscription.add(() => {
        // finally
        this.isLoading = false;
      });
      this.subscriptions.push(subscription);
    
  }
});
  }

  private GetConcurrentRefreshDialog() {
    const dialogRef = this.dialogService.OpenDialog(PackageRefreshDialogComponent, {
      width: '400px',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
      window.location.reload();
    });
  }
}

